import { baseEnvironment } from "./environment.base";

export const environment = {
    ...baseEnvironment,
    environmentName: "development"
};
